import React, { memo } from "react";
import { Link } from "react-router-dom";

const SearchAndExport = memo(function SearchAndExport({
  handleExportApiCall,
  setSearch,
  navigatePath,
  stateData,
  buttonName,
  searchFieldName = "",
  isExport = true,
}) {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="app-search d-none d-lg-block w-25">
          <form>
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                placeholder={`Search ${searchFieldName}...`}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="ri-search-line search-icon text-muted"></span>
            </div>
          </form>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          {isExport && (
            <div className="dropdown mx-3">
              <button
                className="btn btn-outline-primary rounded-2 dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Export
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item cursor_pointer"
                    onClick={() => handleExportApiCall("PDF")}
                  >
                    PDF
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item cursor_pointer"
                    onClick={() => handleExportApiCall("CSV")}
                  >
                    CSV
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item cursor_pointer"
                    onClick={() => handleExportApiCall("EXCEL")}
                  >
                    Excel
                  </a>
                </li>
              </ul>
            </div>
          )}
          {navigatePath &&
            buttonName &&
            (stateData ? (
              <Link
                to={navigatePath}
                state={stateData}
                className="btn rounded-3 buttonColor"
              >
                {buttonName}
              </Link>
            ) : (
              <Link to={navigatePath} className="btn btn-primary rounded-3 ">
                {buttonName}
              </Link>
            ))}
        </div>
      </div>
    </>
  );
});

export default SearchAndExport;
